<script>
import ItemComponent from './Item.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    value: Boolean,
    module: Object,
  },
  data: () => ({
    timer: null,
    timer2: null,
    length: 10,
    next: false,
  }),
  methods: {
    close(item) {
      this.module.close(item);
    },
    open(item) {
      this.$emit('input', false);
      this.module.open = item;
    },
    readAll() {
      this.$emit('input', false);
      this.module.readAll();
    },
    onIntersect() {
      if (this.next) {
        return;
      }
      clearTimeout(this.timer);
      clearTimeout(this.timer2);
      this.next = true;
      this.timer = setTimeout(() => {
        if (this.length < this.module.count) {
          this.length += 5;
        }
        this.timer2 = setTimeout(() => {
          this.next = false;
        }, 100);
      });
    },
  },
  watch: {
    value() {
      this.length = 10;
    },
  },
};
</script>
<template>
  <v-menu
    :value="value"
    @input="$emit('input', $event)"
    left
    bottom
    offset-y
    :close-on-click="true"
    :close-on-content-click="false"
    max-height="80vh"
    max-width="460px"
    min-width="460px"
    class="mag-template-message"
    :disabled="!module.count"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        :disabled="!module.count"
        title="Сообщения"
      >
        <v-badge
          :content="module.count > 100 ?'99+' :module.count"
          :value="module.count"
          color="red"
          overlap
        >
          <v-icon>mdi-email</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list class="pa-0">
      <ItemComponent
        v-for="item in module.items.slice(0, length)"
        :key="item.ID"
        :item="item"
        @open="open(item)"
        @close="close(item)"
      />
    </v-list>
    <div v-intersect="onIntersect" style="height: 2px;margin-top: -2px;"></div>
    <div
      v-if="module.items.length>2"
      v-ripple
      class="mag-template-message__read-all"
      @click="readAll"
    >
      Прочитать всё
    </div>
  </v-menu>
</template>
<style lang="scss">
  .mag-template-message {
    &__item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }

    &__read-all {
      position: sticky;
      bottom: 0;
      background: #ffffff;
      padding: 8px 16px;
      text-align: center;
      color: rgba(0, 0, 0, 0.54);
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      cursor: pointer;
      user-select: none;
      margin-top: -1px;
    }
  }
</style>
